import React from "react";
import { Link } from "react-router-dom";
import { Row, Col, Collapse, CardBody } from "reactstrap";
import { formatDate } from "../../../../Utils/format-date.js";
import { addClassName } from "../../../../Utils/Add-ClassName.js";
import { calcPercentage } from "../../../../Utils/calculate-progress.js";
import Button from "../../../../Utils/Button/index";
import OpPopover from "../../../PopOver/Popover";
import info_black_24dp from "../../../../../images/info_black_24dp.png";
import Renderpopoverinnercontent from "../../../../Dashboard/My-assessments/popover-inner-content";
import LayoutCard from "../../../Layout/Layout";
import completed from "../../../../../images/new-images/completed.png";
import MyReportsIcon from "../../../../../images/new-images/myreports.png";
import "./Reports-Table.css";


const ResponsiveMyReports = (props) => {

  const newFilteredData = [];
  const isAuthParticipant = localStorage.getItem("is_auth_participant");


  props.myReports.filter((filteredArray) => {
    if (filteredArray.assessment_status__status_name === "Report in review") {
      return newFilteredData.push(filteredArray);
    } else if (filteredArray.assessment_status__status_name === "Completed") {
      return newFilteredData.push(filteredArray);
    }
    return null;
  });


  return (
    <LayoutCard headerIcon={MyReportsIcon} headerText="My Reports">
      <div className="Responsive-My-Reports">
        {newFilteredData.length == 0 ? (
          <h6 className="no-reports1">There are no reports avaliable</h6>
        ) : (
          newFilteredData.map((assessment, index) => {
            return (
              <React.Fragment key={index}>
                <Row style={{ height: "2.5em" }}>
                  <img
                    className="assessmentIcon"
                    src={
                      localStorage.getItem("baseLink") +
                      `/media/` +
                      assessment.instrument__instrument_image
                    }
                  />
                  <p className="assessmentName">
                    {assessment.instrument__dashboard_header_text}
                  </p>
                  <OpPopover
                    positions={["left"]}
                    align={"end"}
                    targtElement={
                      <img className="infoIcon" src={info_black_24dp} />
                    }
                    isOpen={props.isPopOverOpenAssessmentId === assessment.id}
                    setOpen={(bool) => {
                      props.handleAssessmentPopOver(
                        bool ? assessment.id : false
                      );
                    }}
                  >
                    <Renderpopoverinnercontent
                      handleClosePopOver={props.handleClosePopOver}
                      assessmentheading={
                        assessment.instrument__dashboard_header_text
                      }
                      assesmentdescription={
                        assessment.instrument__dashboard_header_description
                      }
                    />
                  </OpPopover>
                  <i
                    onClick={() => props.toggleCollapse(assessment.id)}
                    className={props.collapseID === assessment.id ? "fas fa-angle-up" : "fa fa-angle-down"}
                    aria-hidden="true"
                  />
                </Row>
                <Row className="userName">
                  <p>
                    {assessment.participant__full_name}'s{" "}
                    {assessment.instrument__instrument_name}
                  </p>
                </Row>
                <hr />
                <Collapse isOpen={props.collapseID === assessment.id}>
                  <CardBody>
                    <Row>
                      <Col className="title">Date of Expiry</Col>
                      <Col className="details">
                        {" "}
                        {formatDate(assessment.expiry_date)}
                      </Col>
                    </Row>
                    <Row>
                      <Col className="title">Status</Col>
                      <Col className="details">
                        {assessment.assessment_status__status_name ===
                          "In progress" ? (
                          <div
                            className={
                              "assessment-status-text " +
                              addClassName(
                                assessment.assessment_status__status_name
                              )
                            }
                          >
                            {assessment.assessment_status__status_name}
                            {calcPercentage(
                              assessment.assessment_number_count,
                              assessment.assessment_completed_count
                            )}
                          </div>
                        ) : assessment.assessment_status__status_name ===
                          "Completed" ? (
                          <div
                            className={
                              "assessment-status-text " +
                              addClassName(
                                assessment.assessment_status__status_name
                              )
                            }
                          >
                            {assessment.assessment_status__status_name}
                            <img src={completed} alt="Completed Image" />
                          </div>
                        ) : (
                          <div
                            className={
                              "assessment-status-text " +
                              addClassName(
                                assessment.assessment_status__status_name
                              )
                            }
                          >
                            {assessment.assessment_status__status_name}
                          </div>
                        )}
                      </Col>
                    </Row>
                    <hr />
                    {isAuthParticipant === 'true' || !assessment.enable_report ? (
                      <Button type="disabled report">VIEW REPORT</Button>
                    ) : (
                      <Link
                        to={{
                          pathname: `/new/app/reportdownload/${assessment.id}/${assessment.participant__id}`,
                        }}
                      >
                        <Button type="sumit">VIEW REPORT</Button>
                      </Link>
                    )}
                  </CardBody>
                </Collapse>
              </React.Fragment>
            );
          })
        )}
      </div>
    </LayoutCard>
  );
};


export default ResponsiveMyReports;



// WEBPACK FOOTER //
// ./src/new/Components/Reports/My-Reports/Responsive/Reports-Table.jsx